import * as React from 'react';
import * as time from '@tock/shared/utils/time';
import { IntlShape, injectIntl } from 'react-intl';
import { LocalDate } from 'js-joda';
import { Select } from 'ui';
import { SelectChangeEvent } from '@mui/material';
import _ from 'lodash';

// exported for testing
export const fromYears = 20;
export const toYears = 5;
export const currentYear = new Date().getFullYear();
const fromMonth = new Date(currentYear - fromYears, 0);
const toMonth = new Date(currentYear + toYears, 11);

interface Props {
  date: Date;
  onChange: (date: Date) => void;
  intl: IntlShape;
}

function YearMonthPickerV2({ date, onChange, intl }: Props): React.JSX.Element {
  const handleChangeMonth = React.useCallback(
    (e: SelectChangeEvent<HTMLSelectElement>) => {
      onChange(new Date(date.getFullYear(), _.toNumber(e.target.value)));
    },
    [date, onChange]
  );

  const handleChangeYear = React.useCallback(
    (e: SelectChangeEvent<HTMLSelectElement>) => {
      onChange(new Date(_.toNumber(e.target.value), date.getMonth()));
    },
    [date, onChange]
  );

  const years: number[] = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  return (
    <div className="DayPicker-Caption">
      <Select
        data-testid="month-select"
        onBlur={_.noop}
        onChange={handleChangeMonth}
        value={date.getMonth()}
      >
        {_.range(0, 12).map((month: number) => (
          <option key={month} value={month}>
            {time.formatDate(intl, LocalDate.of(date.getFullYear(), month + 1, 1), {
              timeZone: 'UTC',
              month: 'long',
            })}
          </option>
        ))}
      </Select>
      <Select
        data-testid="year-select"
        onBlur={_.noop}
        onChange={handleChangeYear}
        value={date.getFullYear()}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </Select>
    </div>
  );
}

// Preserve PureComponent behavior (shallow prop comparison)
export default injectIntl(React.memo(YearMonthPickerV2));
